interface VerifiedIconProps {
  className?: string;
}

export const VerifiedIcon = ({ className }: VerifiedIconProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M8.75602 14.6666C12.4379 14.6666 15.4227 11.6819 15.4227 7.99998C15.4227 4.31808 12.4379 1.33331 8.75602 1.33331C5.07412 1.33331 2.08936 4.31808 2.08936 7.99998C2.08936 11.6819 5.07412 14.6666 8.75602 14.6666Z"
        stroke="#737373"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75586 8.00002L8.08919 9.33335L10.7559 6.66669"
        stroke="#737373"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
